import React from "react";
import { useAuth } from "@/context/AuthContext";
import PortalDocuments from "@/pages/portal/PortalDocuments";
import ClientDocuments from "@/pages/portal/ClientDocuments";
import PortalMessages from "@/pages/portal/PortalMessages";
import ClientMessages from "@/pages/portal/ClientMessages";
import PartnerReferrals from "@/pages/portal/PartnerReferrals";
import ClientReferrals from "@/pages/portal/ClientReferrals";
import PartnerProfile from "@/pages/portal/PartnerProfile";
import ClientProfile from "@/pages/portal/ClientProfile";

const isClient = (u) => u?.role === "client";

export const DocumentsRoute = () => { const { user } = useAuth(); return isClient(user) ? <ClientDocuments /> : <PortalDocuments />; };
export const MessagesRoute = () => { const { user } = useAuth(); return isClient(user) ? <ClientMessages /> : <PortalMessages />; };
export const ReferralsRoute = () => { const { user } = useAuth(); return isClient(user) ? <ClientReferrals /> : <PartnerReferrals />; };
export const ProfileRoute = () => { const { user } = useAuth(); return isClient(user) ? <ClientProfile /> : <PartnerProfile />; };
